<template>
  <div class="page-wrapper">
    <Header :active-nav="activeNav" @nav-click="scrollToSection" />
    <!-- 轮播图 -->
    <!--<Carousel  />-->

    <div class="page-content">
      <section class="page-title-section">
        <div class="page-title-container">
          <div class="page-title-icon">
            <i class="fas fa-crown"></i>
          </div>
          <h1 class="page-title">品牌故事：百年文脉，味润宁波</h1>
          <p class="page-subtitle">Brand Story</p>
          <div class="page-title-line"></div>
        </div>
      </section>

      <main class="brand-detail">
        <section class="brand-core">
          <div class="brand-card">
            <div class="brand-logo">
              <i class="fas fa-building"></i>
              <div class="brand-badge">1931</div>
            </div>
            <div class="brand-content">
              <h2>太丰 TAI FENG</h2>
              <div class="brand-tagline">
                <span class="badge">浙江老字号</span>
                <span class="badge">抖音黑标品牌</span>
                <span class="badge">卤牛肉干TOP1</span>
              </div>
              <p class="brand-intro">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                始于民国20年(1931年)，近代宁波工业的"三支半烟囱"之一，
                有杜月笙等上海滩大亨、宁波帮人士的入局经营，曾是沪甬两地名震一时的金字招牌。
              </p>
            </div>
          </div>
        </section>

        <section class="brand-milestones">
          <div class="section-header">
            <h3>历史由来</h3>
          </div>
          <div class="milestones-timeline">
            <div
              class="timeline-item"
              v-for="(item, index) in historyList"
              :key="index"
            >
              <div class="timeline-year">{{ index + 1 }}</div>
              <div class="timeline-content">
                <h4>{{ item.title }}</h4>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.description }}</p>
              </div>
            </div>
          </div>
        </section>

        <section class="brand-milestones">
          <div class="section-header">
            <h3>社会贡献</h3>
          </div>
          <div class="milestones-timeline">
            <div
              class="timeline-item"
              v-for="(item, index) in contributions"
              :key="index"
            >
              <div class="timeline-year">{{ index + 1 }}</div>
              <div class="timeline-content">
                <h4>{{ item.title }}</h4>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.description }}</p>
              </div>
            </div>
          </div>
        </section>

        <section class="brand-stats">
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-number">2000<span>万+</span></div>
              <div class="stat-label">累计销量</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">TOP 1</div>
              <div class="stat-label">品类第一</div>
            </div>
          </div>
        </section>

        <section class="products-section">
          <div class="section-header">
            <h3>明星产品系列</h3>
          </div>
          <div class="products-list">
            <div
              class="product-item"
              v-for="product in products"
              :key="product.name"
            >
              <div class="product-icon" :style="{ background: product.color }">
                <i :class="product.icon"></i>
              </div>
              <div class="product-info">
                <h4>{{ product.name }}</h4>
                <p>{{ product.description }}</p>
              </div>
            </div>
          </div>
        </section>

        <section class="channels-section">
          <div class="section-header">
            <h3>渠道网络</h3>
            <p class="section-desc">已入驻各大主流KA连锁商超</p>
          </div>
          <div class="channels-list">
            <div
              class="channel-item"
              v-for="channel in channels"
              :key="channel"
            >
              <span>{{ channel }}</span>
            </div>
          </div>
        </section>

        <section class="story-link">
          <div class="story-card">
            <i class="fas fa-book-open"></i>
            <h3>了解更多品牌故事</h3>
            <p>点击查看太丰品牌的完整故事和发展历程</p>
            <a
              href="https://mp.weixin.qq.com/s/0QSuvRCYKPNpb93J710Y3Q"
              target="_blank"
              class="link-button"
            >
              阅读完整故事 <i class="fas fa-arrow-right"></i>
            </a>
          </div>
        </section>
      </main>
    </div>

    <Footer @scroll-to="scrollToSection" @show-product="showProduct" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Carousel from "@/components/contentPage/Brand_Carousel.vue";

export default {
  name: "Brand",
  components: {
    Header,
    Footer,
    Carousel,
  },
  data() {
    return {
      activeNav: "brand",
      milestones: [
        {
          year: "1931",
          title: "品牌创立",
          description: '近代宁波工业"三支半烟囱"之一',
        },
        {
          year: "1940s",
          title: "名流入局",
          description: "杜月笙等上海滩大亨、宁波帮人士经营",
        },
        {
          year: "2021",
          title: "品牌回归",
          description: '从"吃饱"到"吃好"的品质升级',
        },
        { year: "2024", title: "荣获认证", description: '被评为"浙江老字号"' },
      ],
      historyList: [
        {
          title: "初创与更名",
          description:

            "1931年，立丰面粉厂建立。1934年，金廷荪、杜月笙等13位股东集资收购了立丰厂，成立股份有限公司并定名“太丰”，1935年7月太丰厂正式投产，初期以生产面粉为主，沿用原“牧童牌”商标。",
        },
        {
          title: "艰难发展时期",
          description:
            "抗战初期海运封锁让外埠面粉无法进入宁波，太丰厂借助本地及邻省小麦原料扭转亏损局面；1941年宁波沦陷后，工厂遭日寇掠夺，只能勉强维持少量生产。抗战胜利后工厂全面复工，1949年宁波解放时，太丰厂还主动借面粉解决驻甬部队军需难题。",
        },
        {
          title: "体制变革与转型",
          description:
            "1954年，太丰厂成为宁波最早实行公私合营的企业之一；1966年改名“国营宁波面粉厂”，后来又恢复太丰面粉厂名称并新增国营宁波味精厂招牌。1991年其已发展为全省较大的面粉厂，1993年与中国食品集团有限公司合资组建相关企业，2004年更名为宁波中瑞太丰食品有限公司。2021年，品牌升级为“太丰食业”正式回归，转型聚焦高端休闲零食领域。",
        },
      ],
      contributions: [
        {
          title: "保障民生供给，助力城市稳定",
          description:
            "抗战时期，在原料进口受阻的情况下，太丰厂用本地及邻省小麦生产面粉，满足了宁波民众的口粮需求。1949年宁波解放初期，主动借面粉缓解驻甬部队军粮短缺困境。在计划经济及改革开放初期，作为大型面粉厂，其稳定的面粉产能保障了宁波及周边地区的粮食供应，80年代时品牌在展销会上更是备受民众追捧。转型休闲食品后，推出的古法卤牛肉干等产品，以高营养、高品质满足了现代宁波人对健康休闲食品的需求。",
        },
        {
          title: "推动工业发展，探索经营模式",
          description:
            "太丰作为宁波近代工业“三支半烟囱”之一，是宁波近代工业的重要象征，其早期引入进口设备、规模化生产面粉，为宁波近代工业积累了宝贵的生产和管理经验。1954年率先实行公私合营，为宁波后续企业体制改革提供了示范。90年代后历经改制、合资等变革，2021年转型后又探索线上线下融合的销售模式，通过直播间带货等新方式打开市场，为宁波食品行业的创新发展提供了借鉴。",
        },
        {
          title: "留存工业遗存，活化文化资源",
          description:
            "2005年工厂搬迁后，旧址上的8个高达31.5米的面粉筒、烟囱、水塔等老建筑被保留下来，成为宁波书城的特色景观。这些建筑还实现华丽转型，比如面粉筒变成了“太丰仓艺术楼”，里面入驻了邵洛羊艺术馆等机构，常年举办艺术展，成为宁波滨水工业历史的见证，也为宁波增添了文化艺术展示空间，助力城市文化建设。",
        },
        {
          title: "塑造城市品牌，提升地方影响力",
          description:
            "太丰先后获评宁波老字号、浙江老字号，其产品轻炙·原切牛肉片入选“宁波特色伴手礼”，古法卤牛肉干还斩获iSEE全球美味奖。这些荣誉让太丰成为宁波的一张美食名片，不仅丰富了宁波伴手礼的品类，还通过线上线下渠道将宁波老字号品牌推向全国，提升了宁波特色食品的知名度和城市的文化软实力。",
        },
      ],
      products: [
        {
          name: "古法卤牛肉干",
          description: "传承百年工艺，经典风味",
          icon: "fas fa-drumstick-bite",
          color: "linear-gradient(135deg, #FE4E01, #FF6C2E)",
        },
        {
          name: "风琴牛肉干",
          description: "独特工艺，口感层次丰富",
          icon: "fas fa-music",
          color: "linear-gradient(135deg, #FF6C2E, #FF8C5A)",
        },
        {
          name: "芝香牛肉干",
          description: "芝士与牛肉的完美融合",
          icon: "fas fa-cheese",
          color: "linear-gradient(135deg, #FF8C5A, #FFAB82)",
        },
      ],
      channels: [
        "711",
        "罗森",
        "全家",
        "美宜佳",
        "大润发",
        "永辉超市",
        "盒马鲜生",
        "华润万家",
      ],
    };
  },
  mounted() {
    this.initScroll();
  },
  methods: {
    initScroll() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollToSection(sectionId) {
      this.$router.push({ name: "Home", hash: `#${sectionId}` });
    },
    showProduct(id) {
      this.$router.push({ name: "ProductDetail", params: { id } });
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.page-content {
  flex: 1;
}

.page-title-section {
  background: linear-gradient(
    135deg,
    rgba(158, 19, 23, 0.08),
    rgba(158, 19, 23, 0.02)
  );
  padding: 100px 20px 50px;
  text-align: center;
  position: relative;
}

.page-title-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(to right, #9e1317, #b81c22);
}

.page-title-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 2.5rem;
  color: white;
  box-shadow: 0 10px 25px rgba(158, 19, 23, 0.2);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #222222;
  margin-bottom: 10px;
}

.page-subtitle {
  font-size: 1rem;
  color: #666666;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.page-title-line {
  width: 80px;
  height: 3px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  margin: 0 auto;
  border-radius: 2px;
}

.brand-detail {
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #ffffff;
}

.brand-core {
  margin-bottom: 40px;
}

.brand-card {
  background: rgba(158, 19, 23, 0.03);
  border-radius: 15px;
  padding: 30px;
  display: flex;
  align-items: center;
  gap: 30px;
  border: 1px solid rgba(158, 19, 23, 0.1);
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.brand-logo {
  position: relative;
  flex-shrink: 0;
}

.brand-logo i {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: white;
}

.brand-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #9e1317;
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(158, 19, 23, 0.3);
}

.brand-content h2 {
  font-size: 2rem;
  color: #222222;
  margin-bottom: 15px;
}

.brand-tagline {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}

.badge {
  background: rgba(158, 19, 23, 0.08);
  color: #9e1317;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.9rem;
  border: 1px solid rgba(158, 19, 23, 0.2);
}

.brand-intro {
  font-size: 1rem;
  line-height: 1.6;
  color: #444444;
}

.brand-milestones {
  margin-bottom: 40px;
}

.section-header {
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(158, 19, 23, 0.15);
}

.section-header h3 {
  font-size: 1.5rem;
  color: #222222;
  position: relative;
  display: inline-block;
  padding-right: 15px;
}

.section-header h3::after {
  content: "";
  position: absolute;
  bottom: -12px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  border-radius: 2px;
}

.milestones-timeline {
  display: grid;
  gap: 20px;
}

.timeline-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  background: rgba(158, 19, 23, 0.02);
  border-radius: 12px;
  border-left: 3px solid #9e1317;
  transition: all 0.3s;
}

.timeline-item:hover {
  background: rgba(158, 19, 23, 0.04);
  transform: translateX(5px);
}

.timeline-year {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  background: rgba(158, 19, 23, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 700;
  color: #9e1317;
  border: 2px solid rgba(158, 19, 23, 0.2);
}

.timeline-content h4 {
  font-size: 1.1rem;
  color: #222222;
  margin-bottom: 5px;
}

.timeline-content p {
  font-size: 0.95rem;
  color: #444444;
  line-height: 1.5;
}

.brand-stats {
  margin-bottom: 40px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.stat-item {
  background: rgba(158, 19, 23, 0.03);
  border-radius: 12px;
  padding: 25px 20px;
  text-align: center;
  border: 1px solid rgba(158, 19, 23, 0.1);
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.03);
}

.stat-item:hover {
  background: rgba(158, 19, 23, 0.06);
  border-color: rgba(158, 19, 23, 0.2);
  transform: translateY(-3px);
  box-shadow: 0 8px 16px rgba(158, 19, 23, 0.1);
}

.stat-number {
  font-size: 2rem;
  font-weight: 800;
  color: #9e1317;
  margin-bottom: 8px;
}

.stat-number span {
  color: #b81c22;
  font-size: 1.2rem;
}

.stat-label {
  font-size: 0.9rem;
  color: #666666;
}

.products-section {
  margin-bottom: 40px;
}

.products-list {
  display: grid;
  gap: 15px;
}

.product-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: rgba(158, 19, 23, 0.02);
  border-radius: 12px;
  border: 1px solid rgba(158, 19, 23, 0.1);
  transition: all 0.3s;
}

.product-item:hover {
  background: rgba(158, 19, 23, 0.04);
  transform: translateX(5px);
  border-color: rgba(158, 19, 23, 0.2);
}

.product-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: white;
  flex-shrink: 0;
}

.products .product-icon {
  background: linear-gradient(135deg, #9e1317, #b81c22);
}

.product-info h4 {
  font-size: 1.1rem;
  color: #222222;
  margin-bottom: 5px;
}

.product-info p {
  font-size: 0.9rem;
  color: #444444;
}

.channels-section {
  margin-bottom: 40px;
}

.section-desc {
  color: #666666;
  font-size: 0.95rem;
  margin-top: 5px;
}

.channels-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.channel-item {
  background: rgba(158, 19, 23, 0.08);
  color: #9e1317;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  border: 1px solid rgba(158, 19, 23, 0.2);
  transition: all 0.3s;
}

.channel-item:hover {
  background: rgba(158, 19, 23, 0.12);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(158, 19, 23, 0.1);
}

.story-link {
  margin-bottom: 40px;
}

.story-card {
  background: linear-gradient(
    135deg,
    rgba(158, 19, 23, 0.05),
    rgba(158, 19, 23, 0.01)
  );
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  border: 1px solid rgba(158, 19, 23, 0.15);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.story-card i {
  font-size: 2.5rem;
  color: #9e1317;
  margin-bottom: 15px;
}

.story-card h3 {
  font-size: 1.3rem;
  color: #222222;
  margin-bottom: 10px;
}

.story-card p {
  font-size: 0.95rem;
  color: #444444;
  margin-bottom: 20px;
  line-height: 1.5;
}

.link-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  color: white;
  padding: 10px 25px;
  border-radius: 25px;
  font-size: 0.95rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(158, 19, 23, 0.2);
}

.link-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(158, 19, 23, 0.3);
  gap: 12px;
}

@media (max-width: 768px) {
  .brand-card {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .brand-logo i {
    width: 80px;
    height: 80px;
    font-size: 2.5rem;
  }

  .brand-content h2 {
    font-size: 1.8rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .timeline-item {
    flex-direction: column;
    text-align: center;
  }

  .timeline-year {
    margin: 0 auto;
  }

  .channels-list {
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 2rem;
  }

  .page-title-icon {
    width: 70px;
    height: 70px;
    font-size: 2rem;
  }

  .brand-detail {
    padding: 30px 15px;
  }

  .product-item {
    flex-direction: column;
    text-align: center;
  }
}
</style>
